import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../config";

import { toast } from "react-toastify";
import { IoArrowBack } from "react-icons/io5";
import { v4 as uuidv4 } from "uuid";
import { jwtDecode } from 'jwt-decode';

const aws = require("aws-sdk");
const EditPetDetails = ({ petId, onClose }) => {

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const id = decoded.data.customer_data.id;
  const API_BASE_URL = config.API_BASE_URL;

  const [formData, setFormData] = useState({
    customerId: id,
    name: "",
    gender: "",
    breed: "",
    vaccinated: "",
    vaccination_docs: "",
    pet_bday: "",
    weight: "",
    age: "",
    aggression: "",
  });
  const [errors, setErrors] = useState({});
  const [nameError, setNameError] = useState("");
  const payload = {
    // customerId: id,
    name: formData.name,
    gender: formData.gender,
    breed: formData.breed,
    vaccinated: formData.vaccinated,
    vaccination_docs: formData.vaccination_docs,
    pet_bday: formData.pet_bday,
    weight: formData.weight,
    age: formData.age,
    aggression: formData.aggression,
  };

  const getData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_BASE_URL}/customer/getpet/${petId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      const data = response.data.pet;
  
      setFormData(data);
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response?.data || error.message
      );
    }
  };
  

  useEffect(() => {
    getData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if (name === "name") {
      // Allow only letters and spaces
      formattedValue = value.replace(/[^A-Za-z\s]/g, "");

      if (formattedValue !== value) {
        setNameError("Please enter a character only");
      } else {
        setNameError("");
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue,
    }));
    if (name === "pet_bday") {
      calculateAge(value);
    }
  };
  const calculateAge = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();

    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    let ageString;

    if (age > 0) {
      ageString = `${age} year${age > 1 ? "s" : ""}`;
    } else {
      const months =
        (monthDifference < 0 ? 12 + monthDifference : monthDifference) +
        (dayDifference < 0 ? -1 : 0);
      ageString = `${months} month${months > 1 ? "s" : ""}`;
    }

    setFormData((prevData) => ({
      ...prevData,
      age: ageString,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.breed) newErrors.breed = "Breed is required";
    if (!formData.vaccinated)
      newErrors.vaccinated = "Vaccination status is required";
    if (!formData.pet_bday) newErrors.pet_bday = "Pet birthday is required";
    //if (!formData.age) newErrors.age = "Age is required";
    if (!formData.weight) newErrors.weight = "Weight is required";
    if (!formData.aggression)
      newErrors.aggression = "Aggression status is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
  
    try {
      const token = localStorage.getItem("token"); // get token from local storage
  
      const response = await axios.put(
        `${config.API_BASE_URL}/customer/updatepet/${petId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // send token
          },
        }
      );
  
      if (response.status === 200) {
        toast.success("Pet updated successfully", { position: "top-center" });
        onClose();
      } else {
        toast.error("Please try later", { position: "top-center" });
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
    }
  };
  

  const today = new Date().toISOString().split("T")[0];

  // const [imageUrl, setImageUrl] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const ImageHandler = async (e) => {
    setImageLoading(true);
    try {
      const file = e.target.files[0];
      let myFile = file.name.split(".");
      let myFileType = myFile[myFile.length - 1];
      const s3 = new aws.S3({
        accessKeyId: config.AWS_KEY_ID,
        secretAccessKey: config.AWS_SECRET_KEY,
      });
      const params = {
        Bucket: "finlocalpetchat",
        Key: `${uuidv4()}.${myFileType}`,
        Body: file,
        ContentType: file?.type,
      };
      let { Location } = await s3.upload(params).promise();
      setImageLoading(false);
      return Location;
    } catch (exception) {
      console.error(exception);
      return false;
    } finally {
    }
  };

  const setImage = async (e) => {
    const image = await ImageHandler(e);

    if (image) {
      //   setImageUrl(image);
      setFormData((prevFormData) => ({
        ...prevFormData,
        vaccination_docs: image,
      }));
      //await handleUpload("post_img", image);
    }
  };
  return (
    <div className=" bg-[#fff] flex justify-center items-center">
      <div className="w-full max-w-4xl bg-white  rounded-lg overflow-hidden relative">
        <button
          className="absolute top-0 left-2 text-[#000]   rounded-full h-8 w-8 flex items-center justify-center border border-[#f2f2f2]"
          onClick={onClose}
        >
          <IoArrowBack />
        </button>
        <h1 className="text-xl pl-6 text-center">
          <strong>Edit your pet details : </strong>
        </h1>
        <form className="p-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <label className="block text-gray-700">
                Name <span className="text-[#ff0000]">*</span>{" "}
                {errors.name && (
                  <span className="text-red-500">{errors.name}</span>
                )}
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-gray-700">
                Gender <span className="text-[#ff0000]">*</span>{" "}
                {errors.gender && (
                  <span className="text-red-500">{errors.gender}</span>
                )}
              </label>
              {/* <input
                type="text"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              /> */}
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700">
                Vaccinated <span className="text-[#ff0000]">*</span>{" "}
                {errors.vaccinated && (
                  <span className="text-red-500">{errors.vaccinated}</span>
                )}
              </label>
              <select
                name="vaccinated"
                value={formData.vaccinated}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700">
                Breed <span className="text-[#ff0000]">*</span>{" "}
                {errors.breed && (
                  <span className="text-red-500">{errors.breed}</span>
                )}
              </label>
              <select
                name="breed"
                value={formData.breed}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="small">Small(0-10 kg)</option>
                <option value="medium">Medium(11-20 kg)</option>
                <option value="large">Large(21-40 kg)</option>
                <option value="giants">Giants(40+ kg)</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700">
                Pet Birthday <span className="text-[#ff0000]">*</span>{" "}
                {errors.pet_bday && (
                  <span className="text-red-500">{errors.pet_bday}</span>
                )}
              </label>
              <input
                type="date"
                name="pet_bday"
                value={formData.pet_bday}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                max={today}
              />
            </div>
            <div>
              <label className="block text-gray-700">
                Weight in Kg <span className="text-[#ff0000]">*</span>{" "}
                {errors.weight && (
                  <span className="text-red-500">{errors.weight}</span>
                )}
              </label>
              <input
                type="text"
                name="weight"
                value={formData.weight}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-gray-700">
                Age
                {/*<span className="text-[#ff0000]">*</span>{errors.age && <span className="text-red-500">{errors.age}</span>}*/}
              </label>
              <input
                type="text"
                name="age"
                value={formData.age}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-gray-700">
                Aggression <span className="text-[#ff0000]">*</span>{" "}
                {errors.aggression && (
                  <span className="text-red-500">{errors.aggression}</span>
                )}
              </label>
              <select
                name="aggression"
                value={formData.aggression}
                onChange={handleChange}
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700">
                Vaccination Docs{" "}
                {formData.vaccination_docs ? (
                  <a
                    href={formData.vaccination_docs}
                    className="text-[#0000ff]"
                    target="_blank"
                  >
                    (View Link)
                  </a>
                ) : (
                  ""
                )}
              </label>
              <input
                type="file"
                id="fileInput"
                name="vaccination_docs"
                // value={formData.vaccination_docs}
                onChange={(e) => {
                  setImage(e);
                }}
                accept=".pdf, .doc, .docx, .xls, .xlsx, .jpeg, .png, .gif, video/*"
                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <span className="mt-2 text-sm text-gray-600">
                {formData.vaccination_docs
                  ? "Document Uploaded "
                  : "No document uploaded"}
              </span>
            </div>
            <div className="mt-6 flex justify-end items-center">
              <button
                className="bg-[#FF6216] text-white px-4 py-2 rounded-md shadow-sm  focus:outline-none h-[40px]"
                onClick={handleUpdate}
              >
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPetDetails;
